import request from '@/router/axios'

export function getPostCircleStatisticsSummaryData (param) {
  return request({
    url: '/post/admin/post/statistics/analysis/post/circle/summary',
    method: 'get',
    params: param,
  })
}

export function exportPostCircleStatisticsSummaryData (param) {
  return request({
    url: '/post/admin/post/statistics/analysis/post/circle/summary/export',
    method: 'get',
    params: param,
  })
}